export const SDK_VERSION = '6.16.1';
